export enum SubscribeCode {
  SCALAR = 1,
  DYNAMIC_DATA = 3,
  PARAM = 4,
  STATUS_TOPLEVEL = 5,
  STATUS_TRAIN = 6,
  STATUS_POINT = 7,
}

export interface ISubscribeScalarMessage {
  idMeasure: number;
  Date: string;
  Value1: number | null;
  Value2: number | null;
  AlarmStatus: number;
  data?: number[];
  SubscribeType: SubscribeCode.SCALAR | SubscribeCode.DYNAMIC_DATA;
}

export interface ISubscribeStatusMessage {
  Date: string;
  ObjectId: number;
  ObjectType: number;
  AlarmStatus: number;
  SubscribeType: SubscribeCode.STATUS_TOPLEVEL | SubscribeCode.STATUS_TRAIN | SubscribeCode.STATUS_POINT;
}

export interface ISubscribeParameterMessage {
  Date: string;
  idTrain: number;
  Param?: number;
  Value?: number;
  modeId?: number;
  IdleType?: number;
  SubscribeType: SubscribeCode.PARAM;
}

export type SubscribeMessage = ISubscribeScalarMessage | ISubscribeStatusMessage | ISubscribeParameterMessage;

export type SubscribeListener = (messages: SubscribeMessage[], viewportEnd: Date) => void;

export interface ISubscribeRequest {
  id: number;
  type: SubscribeCode;
}

export interface ISubscribeContext {
  connected: boolean;
  enabled: boolean;
  viewportEnd: Date;
  subscribe: (request: ISubscribeRequest, listener: SubscribeListener) => () => void;
}
